import Chart from "chart.js/auto";
import moment from "moment";


const colors = [
    "rgb(9, 105, 218)",
    "#280e91",
    "rgb(16, 185, 129)",
    "rgb(0,110,47)",
    "rgb(200, 200, 200)"
];

export class ChartBuilder {
    #series = [];
    #labels = [];
    #xAxisFormat = value => {
        let t = moment(value);
        if (moment(value).hour() === 0) {
            return t.format("D MMM");
        }
    };
    #yAxisFormat = value => value;

    constructor() {

    }

    setLabels(labels) {
        this.#labels = labels;
    }

    addSeries(name, data) {
        this.#series.push(
            {
                label: name,
                data: data,
                borderWidth: 3,
                borderColor: colors[this.#series.length],
                backgroundColor: "#fff",
                pointRadius: 4,
            }
        );
    }

    setXAxisFormat(callback) {
        this.#xAxisFormat = callback;
    }

    setYAxisFormat(callback) {
        this.#yAxisFormat = callback;
    }

    build(domElement) {

        let self = this;

        let settings = {
            type: 'line',
            data: {
                labels: this.#labels,
                datasets: this.#series
            },
            options: {
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: "bottom",
                        labels: {
                            usePointStyle: true,
                            boxWidth: 7,
                            boxHeight: 7
                        }
                    },
                    tooltip: {
                        usePointStyle: true,
                        boxWidth: 10,
                        boxHeight: 10,
                        borderWidth: 3,
                        boxPadding: 8,
                        position: "nearest",
                        backgroundColor: "rgba(250, 250, 250, 0.95)",
                        borderColor: "#bbb",
                        titleColor: "#000",
                        bodyColor: "#000",
                        padding: 12,
                        interaction: {
                            intersect: false,
                            mode: 'index',
                        },
                        callbacks: {
                            label: function (toolTipItem) {
                                return toolTipItem.dataset.label + ": " + self.#yAxisFormat(toolTipItem.raw);

                            }
                        }
                    }
                },
                scales: {
                    x: {
                        display: true,
                        ticks: {
                            maxTicksLimit: 20,
                            callback: function (value, index, ticks) {
                                return self.#xAxisFormat(this.getLabelForValue(value));
                            }
                        },
                        grid: {
                            drawOnChartArea: false
                        }
                    },
                    y: {
                        ticks: {
                            maxTicksLimit: 5,
                            callback: self.#yAxisFormat
                        },
                        border: {
                            display: false
                        },
                        beginAtZero: true
                    }
                }
            }
        }

        new Chart(domElement, settings);
    }
}